import gameAssets from "@themed-assets";
import {
  checkToDisplayValueInK,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
  checkToDisplayValueInCr,
} from "@/Common/utils/GameUtils";
import TicketIcon from "@/src/assets/TicketIcon";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import useLobbyConnectionStatus from "@/src/hooks/data/useLobbyConnectionStatus";
import { usePlayer } from "@/src/hooks/data/useLobby";
import {
  TOURNEY_STATUS_COMPLETED,
  TOURNEY_STATUS_LIVE,
  TOURNEY_TYPES,
} from "@/Poker/data/Constants";

function TourneyDetailsEntries({ tourneyDetails, selectedTourneyDetails }) {
  const { tourneyId } = useParams();
  const { connected } = useLobbyConnectionStatus();
  const user = usePlayer();


  const loadingMoreRef = useRef(false);
  const pageRef = useRef(1);
  const lastCallRef = useRef(0);
  const THROTTLE_MS = 800;

  const lastItemRef = useRef(null);

  const {
    // tourneyEntriesData = [],
    prizePool,
    displayWinners,
    tourneyStatus,
    breakEven,
    dynamicPoolPrize,
    prizePoolTickets,
    tourneyIdentifier,
    isFlightTourney,
    isFlightParentTourney,
    parentTourneyName,
    parentTourney,
    currentAvailableFlights,
    flightXThreshold,
    bountyTourney,
    registeredPlayerCount,
    totalReEntryCount,
    activePlayerForTourney,
    tourneyStartTime,
    maxPlayers,
    isAlreadyRegisteredTourney,
    tournamentType,
    totalWinners,
  } = selectedTourneyDetails;
  const tourneyEntriesData = selectedTourneyDetails?.tourneyEntriesData || [];
  const decimalPlaces = isFlightTourney
    ? 2
    : tourneyIdentifier === "completedTourneys"
    ? 0
    : 2;

  useEffect(() => {
    if (connected) {
      tourneyDetails?.fetchTourneyEntries(tourneyId);
    }
  }, [connected, tourneyId, tourneyIdentifier, tourneyStatus]);



const loadMore = useCallback(async () => {
  if (loadingMoreRef.current) return;
  loadingMoreRef.current = true;
  try {
    await tourneyDetails?.fetchTourneyEntries(tourneyId, pageRef.current, 50, "");
    pageRef.current += 1;
  } finally {
    loadingMoreRef.current = false;
  }
}, [tourneyDetails, tourneyId]);

const onEndReach = useCallback(() => {
  const now = Date.now();
  if (now - lastCallRef.current < THROTTLE_MS) return;
  lastCallRef.current = now;
  loadMore();
}, [loadMore]);



  useEffect(() => {
    if (!lastItemRef.current) return;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onEndReach();
        }
      },
      { threshold: 1 }
    );
    observer.observe(lastItemRef.current);
    return () => observer.disconnect();
  }, [tourneyEntriesData, onEndReach]);
  // bountyTourney
  // Position, Name, Prize, Bounty
  // isFlightTourney
  // Position, Name, Prize/Stack,
  // else
  // Players, Position, Prize

  // const sortedEntries = [...tourneyEntriesData].sort((a, b) => {
  //   if (a.playerName === displayName) return -1;
  //   if (b.playerName === displayName) return 1;
  //   return 0;
  // });

  console.log(tourneyEntriesData, "tourneyEntriesData");

  return tourneyEntriesData?.length > 0 ? (
    <div>
      {(tourneyStatus === TOURNEY_STATUS_LIVE ||
        tourneyStatus === TOURNEY_STATUS_COMPLETED ||
        tourneyIdentifier === "completedTourneys") && (
        <div className="mb-3 bg-foreground text-white rounded-300 p-3">
          <div className={`flex items-center justify-between rounded-md`}>
            <div className="text-xs text-secondary w-3/10">Entries</div>
            <div className="text-xs text-secondary w-3/10 truncate">
              Re-entries
            </div>
            <div className="text-xs text-secondary w-4/10">
              {tourneyStatus === TOURNEY_STATUS_COMPLETED ||
              tourneyIdentifier === "completedTourneys"
                ? "Winners"
                : "Remaining Players"}
            </div>
          </div>
          <div className="flex items-center justify-between mt-1.5">
            <div className="text-sm text-primary font-bold w-3/10">
              {/* {tourneyEntriesData?.length ?? "-"} */}
              {registeredPlayerCount || "0"}
            </div>
            <div className="text-sm text-primary w-3/10 truncate font-bold">
              {totalReEntryCount || 0}
            </div>
            <div className="text-sm text-primary w-4/10 truncate font-bold">
              {tourneyStatus === TOURNEY_STATUS_COMPLETED ||
              tourneyIdentifier === "completedTourneys"
                ? totalWinners || 0
                : activePlayerForTourney || 0}
            </div>
          </div>
        </div>
      )}
      {/* section 2 */}
      {tourneyEntriesData?.length > 0 && (
        <div className="bg-foreground/70 text-white rounded-md p-3">
          <div
            className={`flex items-center justify-between px-3 py-2 rounded-md `}
          >
            <div
              className={`text-xs text-secondary font-medium ${
                bountyTourney ? "w-1/9" : "w-1/6"
              }`}
            >
              {tourneyStartTime * 1000 < new Date().getTime() &&
              tourneyStatus !== "CANCELLED"
                ? "Rank"
                : "S.no"}
            </div>
            <div
              className={`text-xs text-secondary font-medium ${
                bountyTourney ? "w-3/9" : "w-3/6"
              }`}
            >
              Players
            </div>
            <div
              className={`text-xs text-secondary font-medium ${
                bountyTourney ? "w-2/9" : "w-2/6"
              }`}
            >
              {tourneyStatus === "CANCELLED" ? "Status" : "Chips/Prizes"}
            </div>
            {bountyTourney && (
              <div
                className={`text-xs w-2/9 text-center font-medium text-secondary`}
              >
                Bounty
              </div>
            )}
          </div>
          <div className="space-y-2">
            {tourneyEntriesData &&
              tourneyEntriesData?.map((eachEntry, index) => (
                <div
                  key={index}
                  className={`flex items-center justify-between px-3 py-4 rounded-300 bg-accent/30  ${
                    index === 0 &&
                    tourneyStatus !== "CANCELLED" &&
                    isAlreadyRegisteredTourney
                      ? "text-warning font-bold text-sm"
                      : eachEntry.rank > 0 && eachEntry.rank <= 2
                      ? "text-primary font-bold text-sm"
                      : "text-secondary font-bold text-sm"
                  }`}
                  ref={index === tourneyEntriesData.length - 1 ? lastItemRef : null}
                >
                  {tourneyStatus === "COMPLETED" ? (
                    <div
                      className={`text-xs  ${
                        bountyTourney ? "w-1/9" : "w-1/6"
                      }`}
                    >
                      {eachEntry.rank === 1 ? (
                        <img
                          src={gameAssets.rank1Icon}
                          className="mr-1 object-cover"
                          height="20px"
                          width="20px"
                        />
                      ) : eachEntry.rank === 2 ? (
                        <img
                          className="mr-1 object-cover"
                          height="20px"
                          width="20px"
                          src={gameAssets.rank2Icon}
                        />
                      ) : eachEntry.rank === 3 ? (
                        <img
                          className="mr-1 object-cover"
                          height="20px"
                          width="20px"
                          src={gameAssets.rank3Icon}
                        />
                      ) : eachEntry.rank == 0 ? (
                        "-"
                      ) : (
                        eachEntry.rank
                      )}
                    </div>
                  ) : (
                    <div
                      className={`text-xs  ${
                        bountyTourney ? "w-1/9" : "w-1/6"
                      }`}
                    >
                      {eachEntry.rank == 0 ? "-" : eachEntry.rank}
                    </div>
                  )}

                  <div
                    className={`text-xs ${
                      bountyTourney ? "w-3/9" : "w-3/6"
                    } truncate`}
                  >
                    {eachEntry.playerName}{" "}
                    {/* {index == 0 && isAlreadyRegisteredTourney ? "(You)" : ""} */}
                    {index == 0 &&
                    eachEntry?.playerName === user?.player?.userName
                      ? "(You)"
                      : ""}
                  </div>
                  <div
                    className={`text-xs ${bountyTourney ? "w-2/9" : "w-2/6"} `}
                  >
                    {eachEntry?.isBustedOut && !eachEntry?.winner ? (
                      <span className={`text-error-primary text-sm font-bold `}>
                        Eliminated
                      </span>
                    ) : (
                      <div className={`flex items-center`}>
                        {tourneyStatus === "CANCELLED" ? (
                          ""
                        ) : index > 3 ? (
                          <img
                            className="mr-1 w-4 h-4"
                            src={gameAssets.ChipStackSecondary}
                          />
                        ) : (
                          <img
                            className="mr-1 w-4 h-4"
                            src={gameAssets.NewChipStack}
                          />
                        )}

                        <span className="inline-flex items-center gap-1">
                          {
                            // isFlightParentTourney &&
                            tourneyIdentifier === "completedTourneys" ||
                            bountyTourney ? (
                              <>
                                {eachEntry.winningAmount > 0 ? (
                                  <>{`₹${parseDecimalValuesOfNumber(
                                    eachEntry.winningAmount,
                                    2,
                                    checkToDisplayValueInK(
                                      eachEntry.winningAmount
                                    ),
                                    checkToDisplayValueInL(
                                      eachEntry.winningAmount
                                    ),
                                    checkToDisplayValueInCr(
                                      eachEntry.winningAmount
                                    )
                                  )}`}</>
                                ) : (
                                  !eachEntry?.ticketAssigned &&
                                  eachEntry.winningBonusAmount <= 0 && (
                                    <>{"-"}</>
                                  )
                                )}
                                {eachEntry.winningBonusAmount > 0 && (
                                  <>
                                    {` + ₹${parseDecimalValuesOfNumber(
                                      eachEntry.winningBonusAmount,
                                      2,
                                      checkToDisplayValueInK(
                                        eachEntry.winningBonusAmount
                                      ),
                                      checkToDisplayValueInL(
                                        eachEntry.winningBonusAmount
                                      )
                                    )} (Bonus)`}
                                  </>
                                )}
                              </>
                            ) : tourneyStatus === "CANCELLED" ? (
                              <p>{eachEntry?.isCredited ? "Refunded" : "-"}</p>
                            ) : (
                              <>
                                {parseDecimalValuesOfNumber(
                                  eachEntry.playerChips,
                                  decimalPlaces,
                                  checkToDisplayValueInK(eachEntry.playerChips),
                                  checkToDisplayValueInL(eachEntry.playerChips),
                                  checkToDisplayValueInCr(eachEntry.playerChips)
                                )}
                              </>
                            )
                          }
                        </span>
                        {eachEntry?.ticketAssigned && (
                          <div className=" flex items-center ml-0.5">
                            {eachEntry.winningAmount > 0 ? "+" : ""}
                            {/* <img className="ml-0.5" src={gameAssets.ChipsStackIcon} /> */}
                            <TicketIcon count={1} width={20} height={20} />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {bountyTourney && (
                    <div className="text-xs w-2/9 text-center">
                      {eachEntry?.bountyAmount > 0
                        ? `₹${parseDecimalValuesOfNumber(
                            eachEntry?.bountyAmount,
                            0,
                            checkToDisplayValueInK(eachEntry?.bountyAmount),
                            checkToDisplayValueInL(eachEntry?.bountyAmount),
                            checkToDisplayValueInCr(eachEntry?.bountyAmount)
                          )} ${
                            eachEntry?.noOfKnockedOutPlayers > 0
                              ? `(${eachEntry?.noOfKnockedOutPlayers})`
                              : ""
                          } `
                        : "-"}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="py-4 text-center justify-center text-sm text-primary font-medium">
      {tournamentType === TOURNEY_TYPES.FLIGHT_PARENT
        ? "List of Entries will be visible once at least 1 flight child has concluded"
        : "Entries will be updated based on the tourney registrations"}
    </div>
  );
}

export default TourneyDetailsEntries;
